import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCategoryArticles } from 'conversations-visitor-experience-components/knowledge-base/clients/kb-api.v3';
import Raven from 'raven-js';
export const fetchCategoryArticles = createAsyncThunk('articles/fetchCategoryArticles', ({
  categoryId,
  knowledgeBaseId,
  knowledgeBaseUrl
}) => {
  return getCategoryArticles({
    categoryId,
    knowledgeBaseId,
    knowledgeBaseUrl
  }).then(res => res).catch(error => {
    Raven.captureException(error);
    throw error;
  });
});